export default {
  // Vin
  Filtro_Fasi_Vino: 'Phases',
  Filtro_Soluzioni_Vino: 'Solutions',
  Filtro_Tipologia_Vino: 'Type de vin',
  Filtro_Certificazioni_Vino: 'Certifications',
  Filtro_Tipologia_Prodotto_Vino: 'Type de Produit',
  // Bière
  Filtro_Stili_Birra: 'Styles',
  Filtro_Fermentazione_Birra: 'Fermentation',

  // Phases
  Fermentazione: 'Fermentation',
  'In vigna': 'Dans le vignoble',
  Uva: 'Raisin',
  Spumantizzazione: 'Effervescence',
  'Mosto/Pigiatura': 'Moût/Foulage',
  Affinamento: 'Élevage',
  Chiarifica: 'Clarification',
  Stabilizzazione: 'Stabilisation',
  Finissaggio: 'Finition',

  // Solutions
  'Aumentare la shelf life': 'Augmenter la durée de conservation',
  'Per fermentazioni difficili': 'Pour les fermentations difficiles',
  'Prevenzione e cura dal bret': 'Prévention et traitement du brett',
  'Prevenzione e cura ossidazioni': 'Prévention et traitement des oxydations',
  'Prevenzione e cura riduzioni lieviti Atecnos':
    'Prévention et traitement des réductions de levures Atecnos',
  'Produzione acido malico': 'Production d’acide malique',
  'Proteggere il colore': 'Protéger la couleur',
  'Arresti fermentativi': 'Arrêts de fermentation',
  'Degradazione acido malico': 'Dégradation de l’acide malique',
  'Per il vigneto': 'Pour le vignoble',
  'Proteggere le uve in fase di raccolta':
    'Protéger les raisins pendant la récolte',
  'Raggiungere la stabilità tartarica': 'Atteindre la stabilité tartrique',

  // Type de vin
  Bianchi: 'Blancs',
  Rossi: 'Rouges',
  Rosati: 'Rosés',
  Spumantizzati: 'Mousseux',
  'Senza solfiti': 'Sans sulfites',
  Aromatici: 'Aromatique',
  Dolci: 'Doux et liquoreux',

  // Certifications
  'ICEA Prodotto Biologico': 'ICEA Produit Biologique',

  // Type de Produit
  'Lieviti Saccharomyces': 'Levures Saccharomyces',
  'Lieviti non Saccharomyces': 'Levures non Saccharomyces',
  'Attivanti secchi': 'Activateurs secs',
  'Autolisati in crema Atecnos': 'Atecnos crème autolysée',
  'Batteri lattici': 'Bactéries lactiques',
  'Da affinamento': 'Du raffinement',
  'In fermentazione': 'Fermentation',
  'In finissaggio': 'Affinage',
  'Per uve e mosti': 'Pour raisins et les moûts',
  'Schizosaccharomyces pombe': 'Schizosaccharomyces pombe',
  'Super anti-ossidanti': 'Super anti-oxydants',

  // Stili Birra
  'English Barleywine': 'English Barleywine',

  'English IPA': 'English IPA',

  'Imperial Stout': 'Imperial Stout',

  'Belgian Pale Ale': 'Belgian Pale Ale',

  'English Brown Ale': 'English Brown Ale',

  'New England IPA': 'New England IPA',

  'Scottish Heavy': 'Scottish Heavy',

  Stout: 'Stout',

  Witbier: 'Witbier',

  'American IPA': 'American IPA',

  'Belgian And French Ale': 'Belgian And French Ale',

  'Belgian Blonde Ale': 'Belgian Blonde Ale',

  'Belgian Dark Strong Ale': 'Belgian Dark Strong Ale',

  'Belgian Strong Ale': 'Belgian Strong Ale',

  'Dry Stout': 'Dry Stout',

  Dubbel: 'Dubbel',

  'English Old Ale': 'English Old Ale',

  'Imperial IPA': 'Imperial IPA',

  'Oatmeal Stout': 'Oatmeal Stout',

  Saison: 'Saison',

  'Scottish Light': 'Scottish Light',

  Tripel: 'Tripel',

  'Vienna Lager': 'Vienna Lager',

  Bock: 'Bock',

  Doppelbock: 'Doppelbock',
  Marzen: 'Marzen',
  'Münchener dunkel': 'Münchener dunkel',
  Oktoberfestbier: 'Oktoberfestbier',
  'Traditional bock': 'Traditional bock',
  Weiss: 'Weiss',
  Pils: 'Pils',
  'Strong English Ale': 'Strong English Ale',
  IPA: 'IPA',
  'Juicy IPA': 'Juicy IPA',
  'Pale ale': 'Pale ale',
  Ale: 'Ale',
  'Amber Lager': 'Amber Lager',
  'American Lager': 'American Lager',
  'Dark Lager': 'Dark Lager',
  Lambic: 'Lambic',
  'Birre speciali': 'Bières spéciales',
  'Birre speziate': 'Bières épicées',
  'Birre aromatiche': 'Bières aromatiques',
  'Rifermentazioni in bottiglia': 'Refermentations en bouteille',
  Porter: 'Porter',
  'Fruit Beer': 'Fruit Beer',
  'American Stout': 'American Stout',
  'American Pale Ale': 'American Pale Ale',
  'American Amber Ale': 'American Amber Ale',
  'American Brown Ale': 'American Brown Ale',
  'American Ale': 'American Ale',
  'American Wheat Ale': 'American Wheat Ale',
  'Berliner Weisse': 'Berliner Weisse',
  'Bière De Garde': 'Bière De Garde',
  'Dusseldorf Altbier': 'Dusseldorf Altbier',
  'German Brown': 'German Brown',
  Kolsch: 'Kolsch',
  'Scottish Heavy': 'Scottish Heavy',
  'Traditional bock': 'Traditional bock',
  'Belgian Dubbel': 'Belgian Dubbel',

  // Fermentazione Birra
  'Alta fermentazione': 'Haute fermentation',
  'Bassa fermentazione': 'Basse fermentation',
}
